import $axios from "../../api";
import axios from "axios"; // raw — PUT langsung ke Spaces (tanpa interceptor/baseURL app)
import { dataUrlToBlob, isFreshDataUrl } from "../../utils/spacesUpload";

// P26_018 Revamp PDP (FR-13) — Dashboard Kategori.
// Categories are sourced elsewhere, so there is no create() — only
// list / detail / update (incl. image) / activate-deactivate.
const PREFIX = "website/category";

const state = () => ({
  isLoading: false,
  isErrors: "",
  page: 1,
  isSuccess: false,
  list: null,
  tree: null,
  detail: null,
});

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  ASSIGN_ERRORS(state, payload) {
    state.isErrors = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_IS_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_TREE(state, payload) {
    state.tree = payload;
  },
  SET_DETAIL(state, payload) {
    state.detail = payload;
  },
};

const actions = {
  getList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX}/list?page=${state.page}&view=${rootState.Main.view}${payload || ""}`)
        .then((res) => {
          commit("SET_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
        });
    });
  },
  getTree({ commit, dispatch }) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX}/tree`)
        .then((res) => {
          commit("SET_TREE", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
        });
    });
  },
  getDetail({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`${PREFIX}/view?id=${payload}`)
        .then((res) => {
          commit("SET_DETAIL", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
        });
    });
  },
  // Jalur 3 — minta presigned PUT URL ke server: { upload_url, headers, filename, public_url }.
  presign({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/presign`, payload)
        .then((res) => resolve(res.data.data))
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  // PUT file mentah LANGSUNG ke Spaces. Instance axios BERSIH: buang header default
  // app (X-Requested-With, X-CSRF-TOKEN, Accept) yang memicu preflight CORS ditolak Spaces.
  uploadToSpaces(_ctx, { uploadUrl, file, headers }) {
    const s3 = axios.create();
    s3.defaults.headers.common = {};
    s3.defaults.headers.put = {};
    return s3.put(uploadUrl, file, {
      headers: headers || { "Content-Type": file.type || "application/octet-stream" },
      transformRequest: [(d) => d],
    });
  },
  // Convenience: base64 → presign + upload ke Spaces → kembalikan filename.
  // Nilai lain (URL lama unchanged / filename / kosong) dikembalikan apa adanya.
  async uploadImageField({ dispatch }, value) {
    if (!isFreshDataUrl(value)) return value;
    const { blob, extension, contentType } = dataUrlToBlob(value);
    const presigned = await dispatch("presign", { extension, content_type: contentType });
    await dispatch("uploadToSpaces", {
      uploadUrl: presigned.upload_url,
      file: blob,
      headers: presigned.headers,
    });
    return presigned.filename;
  },
  update({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/update`, payload)
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("ASSIGN_ERRORS", error.response.data.errors);
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
        });
    });
  },
  showHide({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_IS_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .post(`${PREFIX}/showhide`, { id: payload })
        .then((res) => {
          commit("SET_IS_SUCCESS", true);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
